import { images } from "../source";

export const mainPostData = [
  {
    id: 1,
    name: "Meditation & Yoga",
    slug: "meditation-yoga",
    img: images.mainPost.image,
    alt: images.mainPost.alt,
    date: "20.06.2025",
    title: "Dive Deeper into Wisdom",
    author: "- Marouf Tirad",
    ctaText: "KNOW MORE",
    description: `"Knowing yourself is the beginning of all wisdom." – Aristotle. This profound statement, echoing an ancient truth, underscores a fundamental insight embraced by seekers throughout history: true wisdom begins not with external knowledge, but with an honest and deep understanding of one's inner landscape. It's an invitation to introspection, to discover the essence of who you are, beyond roles and expectations. At Pathways & Perspectives, this essential journey of self-discovery and wider inquiry truly flourishes, and our blog is a vital space for it.
      <br><br>
      We believe that wisdom is far more than accumulated facts or clever insights; it's a profound understanding of life's interconnectedness, a discernment that allows us to navigate complexity with clarity and purpose. Here are a few interpretations of wisdom that guide our exploration:
      <br><br>
      <ol>
        <li><strong>Wisdom as Timeless Truth:</strong> At its core, wisdom is absolute, timeless, and formless – a fundamental truth that underlies all existence. It's the unchanging essence found in ancient teachings across cultures, transcending fleeting trends and personal biases. This deep, universal current informs every authentic path.</li>
        <li><strong>Wisdom as Embodied Experience:</strong> While wisdom stems from a universal source, each individual embodies and expresses it through their own unique subjective experience. This personal journey of integration and understanding is what makes wisdom so powerful and transmittable. It’s about being truly wise rather than merely being right – a shift that cultivates empathy, discernment, and an openness to diverse perspectives, enriching your life immeasurably.</li>
        <li><strong>Wisdom as Practical Discernment in a Modern World:</strong> In our fast-paced, often overwhelming contemporary landscape, wisdom is crucial. It provides the discernment to cut through noise, identify what truly matters, and make choices aligned with our highest good. It’s the capacity to see beyond immediate reactions, to understand consequences, and to act from a place of clarity and inner peace, even amidst chaos and information overload.</li>
      </ol>
      <br>
      Recognizing that your outer world reflects your inner state, wisdom truly begins within. We bring you enlightened individuals, each personally <strong>vetted for their breadth, depth, and genuine understanding,</strong> who have been guided by this universal principle of wisdom. Their shared knowledge and guidance offer more than just perspectives; they provide <strong>complementary experiences that empower you</strong> to shape a more meaningful life. Our blog helps you integrate these powerful truths, serving as a reminder that <strong>wisdom is not just knowledge, but a timeless, living truth</strong> essential for both your inner growth and its manifestation in your outer world.
      <br>
      `,
    mostRead: [
      {
        slug: "health-1",
        img: images.mostPost01.image,
        mbImg: images.mostPostMb01.image,
        alt: images.mostPost01.alt,
        date: "06.04.2024",
        title:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
        link: "",
      },
      {
        slug: "tech-1",
        img: images.mostPost01.image,
        mbImg: images.mostPostMb01.image,
        alt: images.mostPost01.alt,
        date: "06.04.2024",
        title:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
        link: "",
      },
      {
        slug: "health-2",
        img: images.mostPost01.image,
        mbImg: images.mostPostMb01.image,
        alt: images.mostPost01.alt,
        date: "06.04.2024",
        title:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
        link: "",
      },
      {
        slug: "tech-2",
        img: images.mostPost01.image,
        mbImg: images.mostPostMb01.image,
        alt: images.mostPost01.alt,
        date: "06.04.2024",
        title:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
        link: "",
      },
      {
        slug: "health-3",
        img: images.mostPost01.image,
        mbImg: images.mostPostMb01.image,
        alt: images.mostPost01.alt,
        date: "06.04.2024",
        title:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
        link: "",
      },
    ],
    categoriesData: [
      {
        slug: "health-1",
        type: "Health",
        img: images.catPost01.image,
        mbImg: images.catPostMb01.image,
        alt: images.catPost01.alt,
        date: "03.04.2024",
        title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
        author: "- John Duminy",
      },
      {
        slug: "tech-1",
        type: "Tech",
        img: images.catPost02.image,
        mbImg: images.catPostMb02.image,
        alt: images.catPost02.alt,
        date: "21.03.2024",
        title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
        author: "- Chandler Perry",
      },
      {
        slug: "health-2",
        type: "Health",
        img: images.catPost03.image,
        mbImg: images.catPostMb03.image,
        alt: images.catPost03.alt,
        date: "03.04.2024",
        title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
        author: "- John Duminy",
      },
      {
        slug: "tech-2",
        type: "Tech",
        img: images.catPost04.image,
        mbImg: images.catPostMb04.image,
        alt: images.catPost04.alt,
        date: "21.03.2024",
        title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
        author: "- Chandler Perry",
      },
    ],
  },
  // {
  //   id: 2,
  //   name: "Entertainment",
  //   catergory: "entertainment",
  //   img: images.mainPost.image,
  //   alt: images.mainPost.alt,
  //   date: "07.04.2024",
  //   title:
  //     "Lorem ipsum dolor sit amet, nostrud consectetur tempor dolore magna aliqua dummy text",
  //   author: "- Aryna",
  //   mostRead: [
  //     {
  //       slug: "health-1",
  //       img: images.mainPost.image,
  //       alt: images.mainPost.alt,
  //       date: "06.04.2024",
  //       title:
  //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
  //       link: "",
  //     },
  //   ],
  //   categoriesData: [
  //     {
  //       slug: "health-1",
  //       type: "Health",
  //       img: images.catPost01.image,
  //       alt: images.catPost01.alt,
  //       date: "03.04.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- John Duminy",
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   name: "Lifestyle",
  //   catergory: "lifestyle",
  //   img: images.mainPost.image,
  //   alt: images.mainPost.alt,
  //   date: "08.04.2024",
  //   title:
  //     "Lorem ipsum dolor sit amet, nostrud consectetur tempor dolore magna aliqua dummy text",
  //   author: "- Miller",
  //   mostRead: [
  //     {
  //       slug: "tech-1",
  //       img: images.mainPost.image,
  //       mbImg: images.mostPostMb01.image,
  //       alt: images.mainPost.alt,
  //       date: "06.04.2024",
  //       title:
  //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
  //       link: "",
  //     },
  //   ],
  //   categoriesData: [
  //     {
  //       slug: "health-1",
  //       type: "Health",
  //       img: images.catPost01.image,
  //       alt: images.catPost01.alt,
  //       date: "03.04.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- John Duminy",
  //     },
  //     {
  //       slug: "tech-1",
  //       type: "Tech",
  //       img: images.catPost02.image,
  //       alt: images.catPost02.alt,
  //       date: "21.03.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- Chandler Perry",
  //     },
  //   ],
  // },
  // {
  //   id: 4,
  //   name: "meditation & Yoga",
  //   catergory: "meditation",
  //   img: images.mainPost.image,
  //   alt: images.mainPost.alt,
  //   date: "08.04.2024",
  //   title:
  //     "Lorem ipsum dolor sit amet, nostrud consectetur tempor dolore magna aliqua dummy text",
  //   author: "- Miller",
  //   mostRead: [
  //     {
  //       slug: "health-1",
  //       img: images.mostPost01.image,
  //       mbImg: images.mostPostMb01.image,
  //       alt: images.mostPost01.alt,
  //       date: "06.04.2024",
  //       title:
  //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
  //       link: "",
  //     },
  //   ],
  //   categoriesData: [
  //     {
  //       slug: "health-1",
  //       type: "Health",
  //       img: images.catPost01.image,
  //       alt: images.catPost01.alt,
  //       date: "03.04.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- John Duminy",
  //     },
  //     {
  //       slug: "tech-1",
  //       type: "Tech",
  //       img: images.catPost02.image,
  //       alt: images.catPost02.alt,
  //       date: "21.03.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- Chandler Perry",
  //     },
  //     {
  //       slug: "health-2",
  //       type: "Health",
  //       img: images.catPost03.image,
  //       alt: images.catPost03.alt,
  //       date: "03.04.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- John Duminy",
  //     },
  //   ],
  // },
  // {
  //   id: 5,
  //   name: "Holistic Living",
  //   catergory: "holistic",
  //   img: images.mainPost.image,
  //   alt: images.mainPost.alt,
  //   date: "09.04.2024",
  //   title:
  //     "Lorem ipsum dolor sit amet, nostrud consectetur tempor dolore magna aliqua dummy text",
  //   author: "- Miller",
  //   mostRead: [
  //     {
  //       slug: "tech-1",
  //       img: images.mainPost.image,
  //       mbImg: images.mostPostMb01.image,
  //       alt: images.mainPost.alt,
  //       date: "06.04.2024",
  //       title:
  //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
  //       link: "",
  //     },
  //   ],
  //   categoriesData: [
  //     {
  //       slug: "health-1",
  //       type: "Health",
  //       img: images.catPost01.image,
  //       alt: images.catPost01.alt,
  //       date: "03.04.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- John Duminy",
  //     },
  //     {
  //       slug: "tech-1",
  //       type: "Tech",
  //       img: images.catPost02.image,
  //       alt: images.catPost02.alt,
  //       date: "21.03.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- Chandler Perry",
  //     },
  //     {
  //       slug: "health-1",
  //       type: "Health",
  //       img: images.catPost03.image,
  //       alt: images.catPost03.alt,
  //       date: "03.04.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- John Duminy",
  //     },
  //     {
  //       slug: "tech-2",
  //       type: "Tech",
  //       img: images.catPost04.image,
  //       alt: images.catPost04.alt,
  //       date: "21.03.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- Chandler Perry",
  //     },
  //   ],
  // },
  // {
  //   id: 6,
  //   name: "Education",
  //   catergory: "education",
  //   img: images.mainPost.image,
  //   alt: images.mainPost.alt,
  //   date: "09.04.2024",
  //   title:
  //     "Lorem ipsum dolor sit amet, nostrud consectetur tempor dolore magna aliqua dummy text",
  //   author: "- Miller",
  //   mostRead: [
  //     {
  //       slug: "health-1",
  //       img: images.mainPost.image,
  //       alt: images.mainPost.alt,
  //       date: "06.04.2024",
  //       title:
  //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
  //       link: "",
  //     },
  //   ],
  //   categoriesData: [
  //     {
  //       slug: "health-1",
  //       type: "Health",
  //       img: images.catPost01.image,
  //       alt: images.catPost01.alt,
  //       date: "03.04.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- John Duminy",
  //     },
  //   ],
  // },
  // {
  //   id: 7,
  //   name: "Time Management",
  //   catergory: "time",
  //   img: images.mainPost.image,
  //   alt: images.mainPost.alt,
  //   date: "10.04.2024",
  //   title:
  //     "Lorem ipsum dolor sit amet, nostrud consectetur tempor dolore magna aliqua dummy text",
  //   author: "- Miller",
  //   mostRead: [
  //     {
  //       slug: "tech-1",
  //       img: images.mainPost.image,
  //       alt: images.mainPost.alt,
  //       date: "06.04.2024",
  //       title:
  //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
  //       link: "",
  //     },
  //   ],
  //   categoriesData: [
  //     {
  //       slug: "health-1",
  //       type: "Health",
  //       img: images.catPost01.image,
  //       alt: images.catPost01.alt,
  //       date: "03.04.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- John Duminy",
  //     },
  //     {
  //       slug: "tech-1",
  //       type: "Tech",
  //       img: images.catPost02.image,
  //       alt: images.catPost02.alt,
  //       date: "21.03.2024",
  //       title: "Lorem ipsum dolor sit amet, nostrud consectetur tempor",
  //       author: "- Chandler Perry",
  //     },
  //   ],
  // },
];

export const PostsDetailedData = [
  {
    id: 1,
    slug: "health-1",
    bannerDesc: "Lorem ipsum dolor sit amet, nostrud consectetur tempor dolore",
    paraContent: [
      {
        heading: "Lorem Ipsum, Set Dolor Dummy Text",
        desc: [
          "In an era where environmental consciousness is not just a trend but a necessity, the fashion industry faces a significant challenge: integrating sustainability into its core business practices. This shift towards sustainable fashion isn’t just about altering materials or production methods; it’s about rethinking the entire business model. In this context, educational programs like the Executive Program in Fashion Business Management offered by ATLAS Edge play a crucial role in shaping a new generation of fashion leaders who are equipped to drive this change.",
        ],
      },
      {
        heading: "Understanding the Need for Sustainability in Fashion",
        desc: [
          "The fashion industry, historically known for its high carbon footprint and wasteful practices, is at a crossroads. Consumers are increasingly aware of the environmental and social impact of their clothing choices, leading to a growing demand for sustainable fashion. This shift isn’t just a moral imperative but a business one, as sustainability, becomes a key factor in consumer decision-making.",
        ],
        img: images.sustainabilityFashion.image,
        mbImg: images.sustainabilityFashionMb.image,
        alt: images.sustainabilityFashion.alt,
      },
      {
        heading: "The Environmental Impact of Fashion",
        desc: [
          "The fashion industry is one of the largest polluters globally, responsible for significant water consumption, greenhouse gas emissions, and landfill contributions. The need for change is clear, and it starts with integrating sustainability into every aspect of the fashion business.",
        ],
      },
      {
        heading: "The Role of Education in Sustainable Fashion",
        desc: [
          "Educational programs focused on fashion business management are pivotal in this transformation. They equip future industry leaders with the knowledge and tools to:",
          "In an era where environmental consciousness is not just a trend but a necessity, the fashion industry faces a significant challenge: integrating sustainability into its core business practices. This shift towards sustainable fashion isn’t just about altering materials or production methods; it’s about rethinking the entire business model. In this context, educational programs like the Executive Program in Fashion Business Management offered by ATLAS Edge play a crucial role in shaping a new generation of fashion leaders who are equipped to drive this change.",
        ],
      },
    ],
    fbLink: "",
    instaLink: "",
    linkedInLink: "",
  },
  {
    id: 2,
    slug: "tech-1",
    bannerDesc:
      "nostrud consectetur tempor dolore, Lorem ipsum dolor sit amet, ",
    paraContent: [
      {
        heading: "Lorem Ipsum, Set Dolor Dummy Text",
        desc: [
          "In an era where environmental consciousness is not just a trend but a necessity, the fashion industry faces a significant challenge: integrating sustainability into its core business practices. This shift towards sustainable fashion isn’t just about altering materials or production methods; it’s about rethinking the entire business model. In this context, educational programs like the Executive Program in Fashion Business Management offered by ATLAS Edge play a crucial role in shaping a new generation of fashion leaders who are equipped to drive this change.",
        ],
      },
      {
        heading: "Understanding the Need for Sustainability in Fashion",
        desc: [
          "The fashion industry, historically known for its high carbon footprint and wasteful practices, is at a crossroads. Consumers are increasingly aware of the environmental and social impact of their clothing choices, leading to a growing demand for sustainable fashion. This shift isn’t just a moral imperative but a business one, as sustainability, becomes a key factor in consumer decision-making.",
        ],
        img: images.sustainabilityFashion.image,
        mbImg: images.sustainabilityFashionMb.image,
        alt: images.sustainabilityFashion.alt,
      },
    ],
    fbLink: "",
    instaLink: "",
    linkedInLink: "",
  },
  {
    id: 3,
    slug: "health-2",
    bannerDesc: "Lorem ipsum dolor sit amet",
    paraContent: [
      {
        heading: "Understanding the Need for Sustainability in Fashion",
        desc: [
          "The fashion industry, historically known for its high carbon footprint and wasteful practices, is at a crossroads. Consumers are increasingly aware of the environmental and social impact of their clothing choices, leading to a growing demand for sustainable fashion. This shift isn’t just a moral imperative but a business one, as sustainability, becomes a key factor in consumer decision-making.",
        ],
        img: images.sustainabilityFashion.image,
        mbImg: images.sustainabilityFashionMb.image,
        alt: images.sustainabilityFashion.alt,
      },
      {
        heading: "The Environmental Impact of Fashion",
        desc: [
          "The fashion industry is one of the largest polluters globally, responsible for significant water consumption, greenhouse gas emissions, and landfill contributions. The need for change is clear, and it starts with integrating sustainability into every aspect of the fashion business.",
        ],
      },
      {
        heading: "The Role of Education in Sustainable Fashion",
        desc: [
          "Educational programs focused on fashion business management are pivotal in this transformation. They equip future industry leaders with the knowledge and tools to:",
          "In an era where environmental consciousness is not just a trend but a necessity, the fashion industry faces a significant challenge: integrating sustainability into its core business practices. This shift towards sustainable fashion isn’t just about altering materials or production methods; it’s about rethinking the entire business model. In this context, educational programs like the Executive Program in Fashion Business Management offered by ATLAS Edge play a crucial role in shaping a new generation of fashion leaders who are equipped to drive this change.",
        ],
      },
    ],
    fbLink: "",
    instaLink: "",
    linkedInLink: "",
  },
  {
    id: 4,
    slug: "tech-2",
    bannerDesc: "nostrud consectetur tempor dolore",
    paraContent: [
      {
        heading: "The Environmental Impact of Fashion",
        desc: [
          "The fashion industry is one of the largest polluters globally, responsible for significant water consumption, greenhouse gas emissions, and landfill contributions. The need for change is clear, and it starts with integrating sustainability into every aspect of the fashion business.",
        ],
      },
      {
        heading: "The Role of Education in Sustainable Fashion",
        desc: [
          "Educational programs focused on fashion business management are pivotal in this transformation. They equip future industry leaders with the knowledge and tools to:",
          "In an era where environmental consciousness is not just a trend but a necessity, the fashion industry faces a significant challenge: integrating sustainability into its core business practices. This shift towards sustainable fashion isn’t just about altering materials or production methods; it’s about rethinking the entire business model. In this context, educational programs like the Executive Program in Fashion Business Management offered by ATLAS Edge play a crucial role in shaping a new generation of fashion leaders who are equipped to drive this change.",
        ],
      },
    ],
    fbLink: "",
    instaLink: "",
    linkedInLink: "",
  },
  {
    id: 5,
    slug: "health-3",
    bannerDesc: "tempor dolore",
    paraContent: [
      {
        heading: "The Role of Education in Sustainable Fashion",
        desc: [
          "Educational programs focused on fashion business management are pivotal in this transformation. They equip future industry leaders with the knowledge and tools to:",
          "In an era where environmental consciousness is not just a trend but a necessity, the fashion industry faces a significant challenge: integrating sustainability into its core business practices. This shift towards sustainable fashion isn’t just about altering materials or production methods; it’s about rethinking the entire business model. In this context, educational programs like the Executive Program in Fashion Business Management offered by ATLAS Edge play a crucial role in shaping a new generation of fashion leaders who are equipped to drive this change.",
        ],
      },
      {
        heading: "The Environmental Impact of Fashion",
        desc: [
          "The fashion industry is one of the largest polluters globally, responsible for significant water consumption, greenhouse gas emissions, and landfill contributions. The need for change is clear, and it starts with integrating sustainability into every aspect of the fashion business.",
        ],
      },
    ],
    fbLink: "",
    instaLink: "",
    linkedInLink: "",
  },
];

export const paginationPostData = [
  {
    id: 1,
    img: images.paginationPost01.image,
    alt: images.paginationPost01.alt,
    title: "Lorem Ipsum, Set Dolor Dummy Text <br/> Magna",
  },
  {
    id: 2,
    img: images.paginationPost02.image,
    alt: images.paginationPost02.alt,
    title: "Lorem Ipsum, Set Dolor Dummy Text Magna",
  },
  // {
  //   id: 3,
  //   img: images.paginationPost01.image,
  //   alt: images.paginationPost01.alt,
  //   title: "Lorem Ipsum, Set Dolor Dummy Text Magna",
  // },
  // {
  //   id: 4,
  //   img: images.paginationPost01.image,
  //   alt: images.paginationPost01.alt,
  //   title: "Lorem Ipsum, Set Dolor Dummy Text Magna",
  // },
];
